function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function perfumeJsPlugin() {
  var pluginConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var conf = typeof pluginConfig !== 'function' ? pluginConfig : {
    prefume: pluginConfig
  };
  return {
    name: 'prefume.js',
    config: conf,
    initialize: function initialize(_ref) {
      var instance = _ref.instance,
          config = _ref.config;
      var perfume = config.perfume,
          destinations = config.destinations;
      var perfumeOptions = config.perfumeOptions || {};
      var PerfumeInstance = typeof Perfume !== 'undefined' ? Perfume : perfume; // Don't initialize if perfume.js not included

      if (!PerfumeInstance) {
        throw new Error('Perfume.js not found. Verify it is passed into analytics plugin as "perfume" config or set is on window');
        return false;
      }
      /* See https://github.com/Zizzamia/perfume.js#performance-audits */


      var metricNames = ['fp', // firstPaint
      'fcp', // firstContentfulPaint
      'lcp', // largestContentfulPaint
      'lcpFinal', // largestContentfulPaintFinal
      'fid', // firstInputDelay
      'cls', // cumulativeLayoutShift
      'clsFinal', // cumulativeLayoutShiftFinal
      'tbt', // totalBlockingTime
      'tbt10S', // totalBlockingTime10S
      'tbtFinal' // totalBlockingTimeFinal
      ];
      /* Where data should send */

      var dataSinks = !destinations ? {
        all: true
      } : destinations;
      /* Initialize perfume.js tracker */

      new PerfumeInstance(_objectSpread({
        analyticsTracker: function analyticsTracker(_ref2) {
          var metricName = _ref2.metricName,
              data = _ref2.data,
              navigatorInformation = _ref2.navigatorInformation;

          if (metricNames.includes(metricName)) {
            instance.track(metricName, {
              // Google Analytics metrics must be integers, so the value is rounded
              value: metricName === 'cls' ? data * 1000 : data,
              label: navigatorInformation.isLowEndExperience ? 'lowEndExperience' : 'highEndExperience',
              category: config.category || 'perfume.js',
              // Use a non-interaction event to avoid affecting bounce rate
              nonInteraction: true
            }, {
              plugins: dataSinks
            });
          }
        }
      }, perfumeOptions));
    }
  };
}

export default perfumeJsPlugin;
